export default {
  title: 'Illustrazioni per professionisti del settore medico',
  metaDescription:
    "Visualizzate l'anatomia umana con oltre 40.000 illustrazioni biologiche e scientifiche pronte per progettare bellissime infografiche e presentazioni scientifiche ed educative.",
  keywords:
    'illustrazione medica, illustrazione medica vettoriale, anatomia umana visiva, illustrazione biologica, illustrazione scientifica',
  exploreText: '... oppure esplorate tutte le nostre oltre 50 categorie di illustrazioni',
  showMore: 'Mostra tutto',
  checkOutText: 'Scoprite la nostra varietà di',
  createUniqueText:
    'illustrazioni. Utilizzatele per creare illustrazioni scientifiche, accademiche e didattiche uniche.',
  infographicsText: 'infografiche e presentazioni.',

  // category illustrations
  Cardiology: 'Cardiologia',
  Neurology: 'Neurologia',
  Surgery: 'Chirurgia',
  Urology: 'Urologia',
  Gynecology: 'Ginecologia',
  Obstetrics: 'Ostetricia',
  Clinician: 'Clinico',
  Pneumonology: 'Pneumonologia',
  Endocrinology: 'Endocrinologia',
  Orthopedics: 'Ortopedia',
  Pediatrics: 'Pediatria',
  Hematology: 'Ematologia',
  Immunology: 'Immunologia',
  Parasitology: 'Parassitologia',
  Nutrition: 'Nutrizione',
  Odontology: 'Odontoiatria',
  Pharmacy: 'Farmacia',
  Nursing: 'Infermieristica',
  Veterinary: 'Veterinario',
  Zoology: 'Zoologia',
  Botany: 'Botanica',
  'Cell biology': 'Biologia cellulare',
  Development: 'Sviluppo',
  Entomology: 'Entomologia',
  Ornithology: 'Ornitologia',
  Biochemistry: 'Biochimica',
  Chemistry: 'Chimica',
  Genetics: 'Genetica',
  'Molecular Biology': 'Biologia molecolare',
  Nanotechnology: 'Nanotecnologia',
  Neuroscience: 'Neuroscienze',
  Pharmacology: 'Farmacologia',
  Toxicology: 'Tossicologia',
  'Earth Sciences': 'Scienze della Terra',
  Education: 'Educazione',
  Engineering: 'Ingegneria',
  Geography: 'Geografia',
  'Physics & Astronomy': 'Fisica e Astronomia',
  Oceanography: 'Oceanografia',
  'Marine biology': 'Biologia marina',
  History: 'Storia',
  'Others - Molecular Sciences': 'Altri - Scienze Molecolari',
  Others: 'Altri',
};
